import { render, staticRenderFns } from "./userAgreement2.1.vue?vue&type=template&id=2a908192&scoped=true&"
import script from "./userAgreement2.1.vue?vue&type=script&lang=js&"
export * from "./userAgreement2.1.vue?vue&type=script&lang=js&"
import style0 from "./userAgreement2.1.vue?vue&type=style&index=0&id=2a908192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a908192",
  null
  
)

export default component.exports